import { render, staticRenderFns } from "./Khadmin.vue?vue&type=template&id=4c6605df&scoped=true"
import script from "./Khadmin.vue?vue&type=script&lang=js"
export * from "./Khadmin.vue?vue&type=script&lang=js"
import style0 from "./Khadmin.vue?vue&type=style&index=0&id=4c6605df&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6605df",
  null
  
)

export default component.exports